import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useSuperIntl } from "../_";
import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import { Button, Dropdown, Modal, Space } from 'antd';
import dayjs from 'dayjs';
import _ from 'lodash';
import React, { useState } from 'react';
import * as XLSX from 'xlsx';
export var SuperProTableExporter = function SuperProTableExporter(properties) {
  var intl = useSuperIntl();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var downloadExcel = function downloadExcel(data) {
    if (Array.isArray(data) && data.length >= 1) {
      try {
        // 创建一个新的工作簿
        var wb = XLSX.utils.book_new();

        // 将数据转换为工作表
        var ws = XLSX.utils.aoa_to_sheet(data);

        // 设置所有单元格为文本格式
        for (var cell in ws) {
          if (ws.hasOwnProperty(cell) && cell[0] !== '!') {
            ws[cell].z = '@';
          }
        }

        // 将工作表添加到工作簿
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        // 生成Excel文件的二进制数据
        var writeXLSX = XLSX.write(wb, {
          bookType: 'xlsx',
          type: 'array'
        });

        // 创建Blob对象并下载Excel文件
        var blob = new Blob([writeXLSX], {
          type: 'application/octet-stream'
        });
        var link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'data.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } catch (error) {
        Modal.error({
          title: 'Export Failure',
          content: JSON.stringify(error)
        });
      }
    } else {
      Modal.error({
        title: 'Export Failure',
        content: 'An error occurred while exporting data'
      });
    }
  };
  var exportData = function exportData(data) {
    try {
      var xlsxData = [];
      var visibleColumns = _.filter(_.initial(properties.columns), function (column) {
        return column.hideInTable !== true;
      });
      // 处理header
      xlsxData.push(visibleColumns.map(function (column) {
        var _column$title, _column$title2;
        return column !== null && column !== void 0 && (_column$title = column.title) !== null && _column$title !== void 0 && (_column$title = _column$title.props) !== null && _column$title !== void 0 && _column$title.id ? intl.formatMessage({
          id: "".concat(column === null || column === void 0 || (_column$title2 = column.title) === null || _column$title2 === void 0 || (_column$title2 = _column$title2.props) === null || _column$title2 === void 0 ? void 0 : _column$title2.id)
        }) : column.title;
      }));
      // 处理columns
      data.forEach(function (item) {
        var columnData = [];
        visibleColumns.forEach(function (column) {
          var renderData;
          // 渲染表格数据
          if (column.dataIndex) {
            if (column !== null && column !== void 0 && column.renderText) {
              var _column$renderText;
              renderData = (column === null || column === void 0 || (_column$renderText = column.renderText(_, item)) === null || _column$renderText === void 0 || (_column$renderText = _column$renderText.props) === null || _column$renderText === void 0 ? void 0 : _column$renderText.children) || (column === null || column === void 0 ? void 0 : column.renderText(_, item));
            } else if (column !== null && column !== void 0 && column.render) {
              var _column$render;
              renderData = (column === null || column === void 0 || (_column$render = column.render(_, item)) === null || _column$render === void 0 || (_column$render = _column$render.props) === null || _column$render === void 0 ? void 0 : _column$render.children) || (column === null || column === void 0 ? void 0 : column.render(_, item));
            }

            // 解析dataIndex
            var cell = item;
            if (typeof renderData !== 'boolean' && typeof renderData !== 'string' && typeof renderData !== 'number' && !Array.isArray(renderData)) {
              var indexArray = column.dataIndex.replace(/\[([^\]]+)\]/g, '.$1').split('.');
              if (indexArray.length === 1) {
                var _item$indexArray;
                renderData = (_item$indexArray = item[indexArray]) !== null && _item$indexArray !== void 0 ? _item$indexArray : '-';
              } else {
                indexArray.forEach(function (num) {
                  var _cell$num;
                  cell = (_cell$num = cell[num]) !== null && _cell$num !== void 0 ? _cell$num : '-';
                });
                renderData = cell;
              }
            }
            if (renderData && renderData !== '-') {
              // 处理多层嵌套div
              if (Array.isArray(renderData)) {
                renderData = _.join(_.map(renderData, function (i) {
                  var _i$props;
                  return i === null || i === void 0 || (_i$props = i.props) === null || _i$props === void 0 ? void 0 : _i$props.children;
                }), ', ');
              }

              // 解析dateTime
              if ((column === null || column === void 0 ? void 0 : column.valueType) === 'dateTime') {
                renderData = dayjs(renderData).format('YYYY-MM-DD HH:mm:ss');
              }

              // 解析preciseDigit
              if ((column === null || column === void 0 ? void 0 : column.valueType) === 'preciseDigit') {
                var _column$fieldProps, _column$fieldProps2, _column$fieldProps3;
                renderData = column !== null && column !== void 0 && (_column$fieldProps = column.fieldProps) !== null && _column$fieldProps !== void 0 && _column$fieldProps.precision ? (renderData / Math.pow(10, column === null || column === void 0 || (_column$fieldProps2 = column.fieldProps) === null || _column$fieldProps2 === void 0 ? void 0 : _column$fieldProps2.precision)).toFixed(column === null || column === void 0 || (_column$fieldProps3 = column.fieldProps) === null || _column$fieldProps3 === void 0 ? void 0 : _column$fieldProps3.precision) : (renderData / 100).toFixed(2);
              }

              // 解析Enum
              if (column !== null && column !== void 0 && column.valueEnum) {
                var _column$valueEnum$ren;
                if (column !== null && column !== void 0 && (_column$valueEnum$ren = column.valueEnum[renderData]) !== null && _column$valueEnum$ren !== void 0 && (_column$valueEnum$ren = _column$valueEnum$ren.text) !== null && _column$valueEnum$ren !== void 0 && (_column$valueEnum$ren = _column$valueEnum$ren.props) !== null && _column$valueEnum$ren !== void 0 && _column$valueEnum$ren.id) {
                  if (Array.isArray(renderData)) {
                    // 解析多div
                    renderData = _.join(_.map(renderData, function (i) {
                      var _column$valueEnum$i;
                      return intl.formatMessage({
                        id: "".concat(column === null || column === void 0 || (_column$valueEnum$i = column.valueEnum[i]) === null || _column$valueEnum$i === void 0 || (_column$valueEnum$i = _column$valueEnum$i.text) === null || _column$valueEnum$i === void 0 || (_column$valueEnum$i = _column$valueEnum$i.props) === null || _column$valueEnum$i === void 0 ? void 0 : _column$valueEnum$i.id)
                      });
                    }), ', ');
                  } else {
                    var _column$valueEnum$ren2;
                    renderData = intl.formatMessage({
                      id: "".concat(column === null || column === void 0 || (_column$valueEnum$ren2 = column.valueEnum[renderData]) === null || _column$valueEnum$ren2 === void 0 || (_column$valueEnum$ren2 = _column$valueEnum$ren2.text) === null || _column$valueEnum$ren2 === void 0 || (_column$valueEnum$ren2 = _column$valueEnum$ren2.props) === null || _column$valueEnum$ren2 === void 0 ? void 0 : _column$valueEnum$ren2.id)
                    });
                  }
                } else {
                  if (Array.isArray(renderData)) {
                    // 解析多div值
                    renderData = _.join(_.map(renderData, function (i) {
                      var _column$valueEnum$i2;
                      return column === null || column === void 0 || (_column$valueEnum$i2 = column.valueEnum[i]) === null || _column$valueEnum$i2 === void 0 ? void 0 : _column$valueEnum$i2.text;
                    }), ', ');
                  } else {
                    var _column$valueEnum$ren3;
                    renderData = column === null || column === void 0 || (_column$valueEnum$ren3 = column.valueEnum[renderData]) === null || _column$valueEnum$ren3 === void 0 ? void 0 : _column$valueEnum$ren3.text;
                  }
                }
              }
            }
            if (renderData === 0) {
              columnData.push(0);
            } else {
              var _String, _renderData;
              columnData.push(String((_String = String(renderData)) !== null && _String !== void 0 && _String.includes('\n') ? "\"".concat(String(renderData).replace(/"/g, '""'), "\"") : ((_renderData = renderData) !== null && _renderData !== void 0 ? _renderData : column !== null && column !== void 0 && column.dataIndex ? item[column.dataIndex] : renderData) || '-'));
            }
          } else {
            columnData.push('-');
          }
        });
        xlsxData.push(columnData);
      });
      downloadExcel(xlsxData);
    } catch (error) {
      Modal.error({
        title: 'Render Failure',
        content: JSON.stringify(error)
      });
    }
  };
  var getData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(onlyThisPage) {
      var data, dataContainer, currentPage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(0);
            // 预请求
            _context.next = 3;
            return properties.request(properties.context.parameters[0], {}, {});
          case 3:
            data = _context.sent;
            if (!data) {
              _context.next = 30;
              break;
            }
            if (!(onlyThisPage || data.total <= properties.context.parameters[0].pageSize)) {
              _context.next = 9;
              break;
            }
            exportData(data.data);
            _context.next = 28;
            break;
          case 9:
            if (data.total > 500) {
              Modal.warning({
                title: 'Export is processing',
                content: 'Due to the large amount of data that may take a long time to export, please do not perform any other operations during this period to prevent export failure. You can refresh the page to cancel the export.'
              });
            }
            _context.prev = 10;
            dataContainer = [];
            currentPage = 0; // 循环请求分页
          case 13:
            currentPage++;
            _context.t0 = dataContainer;
            _context.next = 17;
            return properties.request(_objectSpread(_objectSpread({}, properties.context.parameters[0]), {}, {
              pageSize: 50,
              current: currentPage
            }), {}, {});
          case 17:
            _context.t1 = _context.sent.data;
            dataContainer = _context.t0.concat.call(_context.t0, _context.t1);
            setLoading(Number((currentPage / (data.total / 50)).toFixed(2)));
          case 20:
            if (currentPage * 50 < data.total) {
              _context.next = 13;
              break;
            }
          case 21:
            // 当数据量不足data.total时说明有请求失败，报出异常
            if (dataContainer.length !== data.total) {
              Modal.error({
                title: 'Request Failure',
                content: 'An error occurred while requesting data'
              });
            } else {
              exportData(dataContainer);
            }
            _context.next = 28;
            break;
          case 24:
            _context.prev = 24;
            _context.t2 = _context["catch"](10);
            setLoading(0);
            Modal.error({
              title: 'Request Failure',
              content: JSON.stringify(_context.t2)
            });
          case 28:
            _context.next = 31;
            break;
          case 30:
            Modal.error({
              title: 'Request Failure',
              content: 'An error occurred while exporting data'
            });
          case 31:
            setLoading(0);
          case 32:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[10, 24]]);
    }));
    return function getData(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var items = [{
    key: 'exportThisPage',
    label: 'Export This Page',
    onClick: function onClick() {
      return getData(true);
    }
  }, {
    key: 'exportAllPage',
    label: 'Export All Pages',
    onClick: function onClick() {
      return getData(false);
    }
  }];
  return loading === 0 ? /*#__PURE__*/React.createElement(Dropdown, {
    menu: {
      items: items
    },
    placement: "bottom"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "text",
    icon: /*#__PURE__*/React.createElement(DownloadOutlined, null)
  })) : /*#__PURE__*/React.createElement(Space, {
    style: {
      width: '60px'
    }
  }, /*#__PURE__*/React.createElement(LoadingOutlined, null), " ".concat(loading, "%"));
};